import {
  Companion_getInstance1ymmu806vd2tw as Companion_getInstance,
  SpecViewgfdgv6h7w5ti as SpecView,
} from './supportModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance_0,
  UUID21wrnrlmk5y1y as UUID,
} from '../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function prepareSpecViewFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [SpecView__id_getInstance(), SpecView_name_getInstance(), SpecView_description_getInstance(), SpecView_isSet_getInstance(), SpecView_parentView_getInstance()];
  var tmp = Companion_getInstance().m2a();
  properties(tmp, (it) => props);
}
function SpecView__id$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(0);
}
function SpecView__id$_get_name_$ref_x9jxdk() {
  return (p0) => p0.k20();
}
function SpecView__id$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function SpecView__id$_get_serializer_$ref_tb5p5d() {
  return (p0) => p0.j2j();
}
function SpecView__id$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(0);
}
function SpecView__id$_get_annotations_$ref_uw94kt() {
  return (p0) => p0.bz();
}
var SpecView__idClass;
function SpecView__id() {
  if (SpecView__idClass === VOID) {
    class $ {
      constructor() {
        SpecView__id_instance = this;
        var tmp = this;
        tmp.i82_1 = lazy(SpecView__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.j82_1 = lazy(SpecView__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.k82_1 = lazy(SpecView__id$annotations$delegate$lambda);
        this.l82_1 = Companion_getInstance_0().m2p();
        this.m82_1 = 'UUID.random()';
      }
      k20() {
        var tmp0 = this.i82_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, SpecView__id$_get_name_$ref_x9jxdk(), null);
        return tmp0.f2();
      }
      n82(receiver) {
        return receiver.o82_1;
      }
      m2j(receiver) {
        return this.n82(receiver instanceof SpecView() ? receiver : THROW_CCE());
      }
      t82(receiver, value) {
        return receiver.u82(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof SpecView() ? receiver : THROW_CCE();
        return this.t82(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.j82_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, SpecView__id$_get_serializer_$ref_tb5p5d(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.k82_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, SpecView__id$_get_annotations_$ref_uw94kt(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'SpecView__id', VOID, VOID, [SerializableProperty()]);
    SpecView__idClass = $;
  }
  return SpecView__idClass;
}
var SpecView__id_instance;
function SpecView__id_getInstance() {
  if (SpecView__id_instance === VOID)
    new (SpecView__id())();
  return SpecView__id_instance;
}
function SpecView_name$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(1);
}
function SpecView_name$_get_name_$ref_uogu5l() {
  return (p0) => p0.k20();
}
function SpecView_name$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function SpecView_name$_get_serializer_$ref_bkmri() {
  return (p0) => p0.j2j();
}
function SpecView_name$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(1);
}
function SpecView_name$_get_annotations_$ref_q2go72() {
  return (p0) => p0.bz();
}
var SpecView_nameClass;
function SpecView_name() {
  if (SpecView_nameClass === VOID) {
    class $ {
      constructor() {
        SpecView_name_instance = this;
        var tmp = this;
        tmp.v82_1 = lazy(SpecView_name$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.w82_1 = lazy(SpecView_name$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.x82_1 = lazy(SpecView_name$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.v82_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, SpecView_name$_get_name_$ref_uogu5l(), null);
        return tmp0.f2();
      }
      n82(receiver) {
        return receiver.p82_1;
      }
      m2j(receiver) {
        return this.n82(receiver instanceof SpecView() ? receiver : THROW_CCE());
      }
      y82(receiver, value) {
        return receiver.u82(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof SpecView() ? receiver : THROW_CCE();
        return this.y82(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.w82_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, SpecView_name$_get_serializer_$ref_bkmri(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.x82_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, SpecView_name$_get_annotations_$ref_q2go72(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'SpecView_name', VOID, VOID, [SerializableProperty()]);
    SpecView_nameClass = $;
  }
  return SpecView_nameClass;
}
var SpecView_name_instance;
function SpecView_name_getInstance() {
  if (SpecView_name_instance === VOID)
    new (SpecView_name())();
  return SpecView_name_instance;
}
function SpecView_description$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(2);
}
function SpecView_description$_get_name_$ref_qkuhbq() {
  return (p0) => p0.k20();
}
function SpecView_description$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function SpecView_description$_get_serializer_$ref_1kap9t() {
  return (p0) => p0.j2j();
}
function SpecView_description$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(2);
}
function SpecView_description$_get_annotations_$ref_6g780l() {
  return (p0) => p0.bz();
}
var SpecView_descriptionClass;
function SpecView_description() {
  if (SpecView_descriptionClass === VOID) {
    class $ {
      constructor() {
        SpecView_description_instance = this;
        var tmp = this;
        tmp.z82_1 = lazy(SpecView_description$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.a83_1 = lazy(SpecView_description$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.b83_1 = lazy(SpecView_description$annotations$delegate$lambda);
        this.c83_1 = null;
        this.d83_1 = 'null';
      }
      k20() {
        var tmp0 = this.z82_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, SpecView_description$_get_name_$ref_qkuhbq(), null);
        return tmp0.f2();
      }
      n82(receiver) {
        return receiver.q82_1;
      }
      m2j(receiver) {
        return this.n82(receiver instanceof SpecView() ? receiver : THROW_CCE());
      }
      e83(receiver, value) {
        return receiver.e80(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof SpecView() ? receiver : THROW_CCE();
        return this.e83(tmp, (value == null ? true : typeof value === 'string') ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.a83_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, SpecView_description$_get_serializer_$ref_1kap9t(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.b83_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, SpecView_description$_get_annotations_$ref_6g780l(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'SpecView_description', VOID, VOID, [SerializableProperty()]);
    SpecView_descriptionClass = $;
  }
  return SpecView_descriptionClass;
}
var SpecView_description_instance;
function SpecView_description_getInstance() {
  if (SpecView_description_instance === VOID)
    new (SpecView_description())();
  return SpecView_description_instance;
}
function SpecView_isSet$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(3);
}
function SpecView_isSet$_get_name_$ref_hsy31i() {
  return (p0) => p0.k20();
}
function SpecView_isSet$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function SpecView_isSet$_get_serializer_$ref_9b26b7() {
  return (p0) => p0.j2j();
}
function SpecView_isSet$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(3);
}
function SpecView_isSet$_get_annotations_$ref_bp9urz() {
  return (p0) => p0.bz();
}
var SpecView_isSetClass;
function SpecView_isSet() {
  if (SpecView_isSetClass === VOID) {
    class $ {
      constructor() {
        SpecView_isSet_instance = this;
        var tmp = this;
        tmp.f83_1 = lazy(SpecView_isSet$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.g83_1 = lazy(SpecView_isSet$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.h83_1 = lazy(SpecView_isSet$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.f83_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, SpecView_isSet$_get_name_$ref_hsy31i(), null);
        return tmp0.f2();
      }
      n82(receiver) {
        return receiver.r82_1;
      }
      m2j(receiver) {
        return this.n82(receiver instanceof SpecView() ? receiver : THROW_CCE());
      }
      i83(receiver, value) {
        return receiver.u82(VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof SpecView() ? receiver : THROW_CCE();
        return this.i83(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.g83_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, SpecView_isSet$_get_serializer_$ref_9b26b7(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.h83_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, SpecView_isSet$_get_annotations_$ref_bp9urz(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'SpecView_isSet', VOID, VOID, [SerializableProperty()]);
    SpecView_isSetClass = $;
  }
  return SpecView_isSetClass;
}
var SpecView_isSet_instance;
function SpecView_isSet_getInstance() {
  if (SpecView_isSet_instance === VOID)
    new (SpecView_isSet())();
  return SpecView_isSet_instance;
}
function SpecView_parentView$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(4);
}
function SpecView_parentView$_get_name_$ref_o8zr7f() {
  return (p0) => p0.k20();
}
function SpecView_parentView$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function SpecView_parentView$_get_serializer_$ref_ilb44e() {
  return (p0) => p0.j2j();
}
function SpecView_parentView$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(4);
}
function SpecView_parentView$_get_annotations_$ref_800yje() {
  return (p0) => p0.bz();
}
var SpecView_parentViewClass;
function SpecView_parentView() {
  if (SpecView_parentViewClass === VOID) {
    class $ {
      constructor() {
        SpecView_parentView_instance = this;
        var tmp = this;
        tmp.j83_1 = lazy(SpecView_parentView$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.k83_1 = lazy(SpecView_parentView$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.l83_1 = lazy(SpecView_parentView$annotations$delegate$lambda);
        this.m83_1 = null;
        this.n83_1 = 'null';
      }
      k20() {
        var tmp0 = this.j83_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, SpecView_parentView$_get_name_$ref_o8zr7f(), null);
        return tmp0.f2();
      }
      n82(receiver) {
        return receiver.s82_1;
      }
      m2j(receiver) {
        return this.n82(receiver instanceof SpecView() ? receiver : THROW_CCE());
      }
      o83(receiver, value) {
        return receiver.e80(VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof SpecView() ? receiver : THROW_CCE();
        return this.o83(tmp, (value == null ? true : value instanceof UUID()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.k83_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, SpecView_parentView$_get_serializer_$ref_ilb44e(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.l83_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, SpecView_parentView$_get_annotations_$ref_800yje(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'SpecView_parentView', VOID, VOID, [SerializableProperty()]);
    SpecView_parentViewClass = $;
  }
  return SpecView_parentViewClass;
}
var SpecView_parentView_instance;
function SpecView_parentView_getInstance() {
  if (SpecView_parentView_instance === VOID)
    new (SpecView_parentView())();
  return SpecView_parentView_instance;
}
//region block: exports
export {
  prepareSpecViewFields as prepareSpecViewFields24nshxp1fdn9z,
};
//endregion

//# sourceMappingURL=SpecViewFields.mjs.map
